import { getScoreCardsByUserV2 } from '@/lib/api/score';
import React from 'react';

export interface PopoverContentDevProps {
  userUuid?: string;
}

/**
 * Developer menu content rendered inside PageHeader popover.
 */
export const PopoverContentDev: React.FC<PopoverContentDevProps> = ({
  userUuid,
}) => {
  if (!userUuid) return null;

  const handleClick = () => {
    getScoreCardsByUserV2(userUuid, true).then((res) => console.log(res));
  };

  return (
    <div>
      <ul className="space-y-4 text-base text-neutral-black">
        <li>
          <button onClick={handleClick}>getScoreCardsByUserV2</button>
        </li>
      </ul>
    </div>
  );
};

PopoverContentDev.displayName = 'PopoverContentDev';

export default PopoverContentDev;
